
/**
 * @param {React.Component} Component React component
 * @returns {string} component name (or default name if unrecognized)
 */
export const getDisplayName = Component => Component.displayName || Component.name || 'Component';
